<ion-content>
  <header>
    <app-page-header class="size-header">
      <div class="search-bar-area" centered>
        <ion-input
          autocomplete="off"
          (ionChange)="search()"
          [(ngModel)]="filter.Search"
          class="search_bar"
          placeholder="{{ 'common.search' | translate }}"></ion-input>
      </div>
    </app-page-header>
  </header>

  <main class="lov center">
    <app-news-card-list
      title="{{ title | i18n }}"
      class="reduced_zone"
      [back]="true"
      [categories]="true"
      [categoryId]="filter.CategoryId"
      [notFound]="notFound"
      [empty]="empty"
      [color]="'var(--ion-color-primary)'"
      [loading]="Loading"
      [moreButton]="false">
      @if (Loading) {
        <div data class="lov">
          <div class="fit">
            <ion-grid>
              <ion-row>
                <ion-col class="medium-post" *ngFor="let news of fakeElementsLarg" sizeLg="5.5" sizeMd="5" sizeXs="12">
                  <app-post-medium-loading class="medium-post"></app-post-medium-loading>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </div>
      } @else {
        <div data class="lov">
          <div class="fit">
            <ion-grid>
              <ion-row class="jc">
                <ion-col *ngFor="let n of news; let i = index" class="medium-post" sizeLg="5.5" sizeMd="5" sizeXs="12">
                  <app-post-large class="full-width" (click)="changeParams(n.id)" [news_data]="news[i]"></app-post-large>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>

          <div class="text-align-center" *ngIf="news.length > 0">
            <ion-button *ngIf="moreResults" fill="clear" (click)="ionViewWillEnter(true)" class="ion-no-padding" size="small">
              <ion-label color="primary" style="text-align: center" translate>common.more</ion-label>
            </ion-button>

            <div *ngIf="!endResults">
              <ion-button fill="clear" class="ion-no-padding" *ngIf="!moreResults" expand="block">
                <ion-spinner name="crescent"></ion-spinner>
              </ion-button>
            </div>
          </div>
        </div>
      }
    </app-news-card-list>

    <app-empty-result [hidden]="!empty || filter.Highlights || filter.Search || filter.CategoryId || filter.EditorialId"></app-empty-result>
    <app-not-found [hidden]="!notFound || filter.Highlights || filter.Search || filter.CategoryId || filter.EditorialId"></app-not-found>
  </main>
</ion-content>
